import { getNameInitials } from "../../../../utils/functions";
import styles from "./ThreadItem.module.css";

const COLOR_CLASSES = ["color0", "color1", "color2", "color3", "color4"];

export default function ThreadItem({ thread, active, onClick }) {
  const colorClass = styles[COLOR_CLASSES[thread.color] || "color0"];

  return (
    <div
      className={`${styles.threadItem} ${thread.unread ? styles.unread : ""} ${active ? styles.active : ""}`}
      onClick={onClick}
    >
      <div className={`${styles.threadAvatar} ${colorClass}`}>
        {getNameInitials(thread.sender)}
        <div className={styles.unreadRing} />
      </div>
      <div className={styles.threadBody}>
        <div className={styles.threadTop}>
          <span className={styles.threadSubject}>{thread.subject}</span>
          <span className={styles.threadTime}>{thread.timestamp}</span>
        </div>
        <div className={styles.threadSender}>
          {thread.sender} · {thread.email}
        </div>
        <div className={styles.threadPreview}>{thread.preview}</div>
        <div className={styles.threadMeta}>
          <span className={`${styles.typeBadge} ${styles[thread.badgeClass]}`}>
            {thread.type}
          </span>
          {thread.unread && <span className={styles.unreadCount}>1</span>}
        </div>
      </div>
    </div>
  );
}
